export default __webpack_public_path__ + "static/media/oscer-pres-laceration.ccda858b.svg";